// ✅ Updated Home.jsx — add GoogleReviews and LocalBusinessSchema

import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import ServicesPreview from '../components/ServicesPreview';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import GoogleReviews from '../components/GoogleReviews';  // ← NEW
import CTA from '../components/CTA';
import LocalBusinessSchema from '../components/LocalBusinessSchema';  // ← NEW

const Home = () => {
  return (
    <>
      <LocalBusinessSchema />  {/* ← NEW - SEO schema */}
      <Helmet>
        <title>Tayyab Electric Studio — Professional Electrical Services in Baramulla, Kashmir</title>
        <meta name="description" content="Tayyab Electric Studio offers professional electrical installation, CCTV, smart home automation, solar power & security systems in Baramulla, Kashmir. 13+ years experience. Call +91 99066 69918." />
        <meta name="keywords" content="electrician Baramulla, CCTV installation Kashmir, solar power Baramulla, smart home automation Kashmir, electrical contractor J&K" />
        <meta property="og:title" content="Tayyab Electric Studio — Baramulla Kashmir" />
        <meta property="og:description" content="Professional electrical services, CCTV, solar & smart home automation in Baramulla, Kashmir." />
        <meta property="og:image" content="https://arstc.netlify.app/og-image.jpg" />
        <meta property="og:url" content="https://arstc.netlify.app" />
        <meta name="geo.region" content="IN-JK" />
        <meta name="geo.placename" content="Baramulla" />
      </Helmet>
      <Hero />
      <Stats />
      <ServicesPreview />
      <WhyChooseUs />
      <Testimonials />
      <GoogleReviews />  ← NEW - after Testimonials
      <CTA />
    </>
  );
};

export default Home;